import { useEffect } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import get from 'lodash/get';

const svgRegistry = !__SERVER__ && get(window, '__SERVER_CONTEXT__.svgRegistry', {}); // used only on client
let serverSideUsedSvg = {};

export function flushServerSideUsedSvg() {
    const copy = { ...serverSideUsedSvg };
    serverSideUsedSvg = {};
    return copy;
} // used in server only

/**
 * @return {null|portal}
 */
export default function SvgPortal({ children }) {
    const name = children.props.id;
    if (__SERVER__) {
        serverSideUsedSvg[name] = children;
        return null;
    }

    useEffect(() => {
        if (!svgRegistry[name]) {
            const container = document.querySelector('#svgSpriteContainer');
            svgRegistry[name] = true;
            if (container) {
                container.innerHTML += renderToStaticMarkup(children);
            }
        }
    }, [children]);

    return null;
}
